var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHombresAdultos = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "87px",
    height: "87px",
    viewBox: "0 0 87 87",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Salida-datos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inicio-selecci\\xF3n-multiple-de-eventos-copy-19",
    transform: "translate(-416.000000, -393.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(416.000000, 393.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-10",
    fill: "#6BC33C",
    opacity: 0.74546596,
    cx: 43.5,
    cy: 43.5,
    r: 43.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.186016,24.869344 C46.459136,24.869344 49.120832,22.20736 49.120832,18.934672 C49.120832,15.661984 46.459136,13 43.186016,13 C39.91376,13 37.251344,15.661984 37.251344,18.934672 C37.251344,22.20736 39.91376,24.869344 43.186016,24.869344 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.337616,43.802032 C57.373904,43.68568 57.382256,43.560112 57.35792,43.433248 L54.403904,27.76144 C54.166592,26.294944 52.919984,25.231792 51.439952,25.231792 L34.931648,25.231792 C33.450896,25.231792 32.204864,26.296096 31.97216,27.741856 L29.01368,43.433248 C28.98992,43.560112 28.997696,43.68568 29.033696,43.802032 C29.0108,43.945744 29,44.083264 29,44.221648 C29,45.880816 30.35,47.230816 32.010032,47.230816 C33.460544,47.230816 34.702544,46.193872 34.967648,44.748544 L36.831872,33.095344 L36.807824,70.281904 C36.807824,71.941936 38.157104,73.290496 39.816992,73.290496 C41.47688,73.290496 42.82688,71.940496 42.82688,70.281904 L42.82688,51.875248 L43.544864,51.875248 L43.544864,70.28176 C43.544864,71.941792 44.895152,73.290496 46.555904,73.290496 C48.214928,73.290496 49.564496,71.940352 49.564496,70.281184 L49.54016,33.095344 L51.407408,44.765824 C51.669488,46.193872 52.912496,47.230816 54.363008,47.230816 C56.022176,47.230816 57.372176,45.880816 57.372176,44.221648 C57.371744,44.083264 57.360944,43.94416 57.337616,43.802032 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHombresAdultos, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HombresAdultos.8aa6ace1.svg";
export { ForwardRef as ReactComponent };